// src/pages/Consultation/SessionDetail/Tabs/TimelineTab.jsx
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSessionTimelineThunk } from "../../../../store/thunks/consultationThunks";
import { FiClock } from "react-icons/fi";

const TimelineTab = ({ session }) => {
  const dispatch = useDispatch();
  const { sessionTimeline, loadingEvents } = useSelector(
    (state) => state.consultation
  );

  useEffect(() => {
    if (session._id) {
      dispatch(getSessionTimelineThunk(session._id));
    }
  }, [session._id, dispatch]);

  const getEventIcon = (eventType) => {
    const iconMap = {
      SESSION_STARTED: "🟢",
      SESSION_PAUSED: "⏸️",
      SESSION_RESUMED: "▶️",
      ITEM_ADDED_TO_CART: "🛒",
      ITEM_REMOVED_FROM_CART: "❌",
      PRICE_CALCULATED: "💰",
      PRICE_LOCKED: "🔒",
      ORDER_CREATED: "📦",
    };
    return iconMap[eventType] || "📌";
  };

  if (loadingEvents) {
    return (
      <div className="text-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {sessionTimeline && sessionTimeline.length > 0 ? (
        <div className="relative">
          {/* Timeline Line */}
          <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-gray-200"></div>

          {/* Events */}
          <div className="space-y-4">
            {sessionTimeline.map((event, index) => (
              <div
                key={index}
                className="relative flex items-start gap-4 pl-10"
              >
                {/* Icon */}
                <div className="absolute left-0 w-8 h-8 bg-white border-2 border-gray-200 rounded-full flex items-center justify-center text-lg">
                  {getEventIcon(event.eventType)}
                </div>

                {/* Content */}
                <div className="flex-1 bg-white rounded-lg border p-4">
                  <div className="flex justify-between items-start mb-2">
                    <h4 className="font-medium text-gray-900">
                      {event.eventType.replace(/_/g, " ")}
                    </h4>
                    <span className="text-xs text-gray-500">
                      {new Date(event.timestamp).toLocaleTimeString()}
                    </span>
                  </div>

                  {event.description && (
                    <p className="text-sm text-gray-600">{event.description}</p>
                  )}

                  {event.actor && (
                    <p className="text-xs text-gray-500 mt-2">
                      By: {event.actor.adminName || event.actor.type}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="text-center py-12">
          <FiClock className="mx-auto text-5xl text-gray-400 mb-4" />
          <p className="text-gray-500">No timeline events yet</p>
        </div>
      )}
    </div>
  );
};

export default TimelineTab;
